const initialState = {
  data: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    files: []
  },
  isLoading: false,
  hasErrored: false,
  countFails: 0,
  countRepository: 0,
  uploadingFiles: [],
  filesUploading: {
    showFileUploadedMessage: false,
    successUploaded: false
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case '[FILES] HAS_ERRORED':
      return { ...state, isLoading: false, data: initialState.data, hasErrored: true };
    case '[FILES] IS_LOADING':
      return { ...state, hasErrored: false, data: initialState.data, isLoading: true };
    case '[FILES] FETCH_SUCCESS':
      return { ...state, hasErrored: false, isLoading: false, data: action.data };
    case '[FILES] FETCH_SUCCESS_COUNT':
      return { ...state, hasErrored: false, isLoading: false, countRepository: action.data.count };
    case '[FILES] COUNT_FAILS':
      return { ...state, countFails: action.countFails };
    case '[FILES] COUNT_REPOSITORY':
      return { ...state, countRepository: action.countRepository };
    case '[FILES] FILES_UPLOADING_UPDATE_FILES':
      return { ...state, uploadingFiles: action.uploadingFiles };
    case '[FILES] FILES_UPLOADING_UPDATE_FILE':
      return { ...state, uploadingFiles: state.uploadingFiles.map(f => (f.id === action.file.id ? action.file : f)) };
    case '[FILES] FILES_UPLOADING_REMOVE_FILE':
      return { ...state, uploadingFiles: state.uploadingFiles.filter(f => f.id !== action.file.id) };
    case '[FILES] FILES_UPLOADED_SUCCESS':
      return { ...state, filesUploading: { ...initialState.filesUploading, showFileUploadedMessage: action.file.showFileUploadedMessage, successUploaded: action.file.successUploaded } };
    case '[FILES] FILES_UPLOADED_SUCCESS_HIDE_MESSAGE':
      return { ...state, filesUploading: { ...initialState.filesUploading, showFileUploadedMessage: action.file.showFileUploadedMessage, successUploaded: action.file.successUploaded } };
    default:
      return state;
  }
};
